import React from "react";
import secToMin from "../../utils/secToMin";
import { IoCloseOutline } from "react-icons/io5";
import { MdDragIndicator } from "react-icons/md";

function GiftSong({
  data,
  isInteractive,
  isWebPlayer,
  removeSong,
  playingSong,
  onPlay,
  onPause,
}) {
  const { Title: title, Stage_Name: artist, Length: length } = data;
  const isPlaying = playingSong === data.Storage_Preview;

  return (
    <div
      className={`gift-song ${isInteractive ? "interactive" : ""} ${
        isWebPlayer ? "gift-song-web-player" : ""
      } ${
        isPlaying ? "gift-song-web-playing" : ""
      }  `}
    >
      {isInteractive && (
        <>
          <MdDragIndicator
            fontSize={19}
            style={{
              position: "absolute",
              top: "50%",
              left: "28px",
              transform: "translateY(-50%)",
              color: !isPlaying ? "#F98050" : "#FFFDEF",
              // opacity: 0.9,
              cursor: "move",
              zIndex: 50,
            }}
            onClick={() => {}}
          />
          <IoCloseOutline
            fontSize={21}
            style={{
              position: "absolute",
              top: "50%",
              right: "30px",
              transform: "translateY(-50%)",
              color: !isPlaying ? "#F98050" : "#FFFDEF",
              cursor: "pointer",
              zIndex: 50,
            }}
            onClick={() => removeSong(data)}
          />
        </>
      )}
      <p
        style={{
          color: isWebPlayer ? "#2C2B26" : "#FFFDEF",
          fontWeight: isWebPlayer ? "400" : "200",
        }}
      >
        {title}
      </p>
      <p
        style={{
          letterSpacing: "0.045em",
          color: isWebPlayer ? "#2C2B26" : "#FFFDEF",
          fontWeight: isWebPlayer ? "300" : "200",
        }}
      >
        {artist}
      </p>
      <button
        className="transparentBtn fill-song-with-button"
        style={{
          position: "absolute",
          height: "35px",
          width: "100px",
          top: "10%",
          left: "60px",
          // transform: "translateY(-50%)",
          // color: "#F98050",
          cursor: "pointer",
          zIndex: 50,
        }}
        onClick={() => {
          if (isInteractive || isWebPlayer) {
            if (isPlaying) {
              onPause();
            } else {
              onPlay(data);
            }
          }
        }}
      />
      <p
        style={
          isInteractive || isWebPlayer
            ? {
                letterSpacing: "0.06em",
                fontFamily: "Work sans",
                fontSize: "12px",
                position: "absolute",
                top: 26,
                right: 70,
                color: isWebPlayer ? "#2C2B26" : "#FFFDEF",
                fontWeight: isWebPlayer ? "400" : "200",
              }
            : {
                letterSpacing: "0.06em",
                fontFamily: "Work sans",
                fontSize: "10px",
                position: "absolute",
                top: 36,
                right: 70,
                color: isWebPlayer ? "#2C2B26" : "#FFFDEF",
                fontWeight: isWebPlayer ? "400" : "200",
              }
        }
      >
        {secToMin(length)}
      </p>
      <hr
        style={
          isInteractive
            ? {
                border: "none",
                height: "0",
                borderTop: isWebPlayer
                  ? "1px solid #2C2B26"
                  : "1px solid #FFFDEF",
                marginTop: "4px",
                marginBottom: "5px",
                opacity: "0.8",
              }
            : {
                border: "none",
                height: "0",
                borderTop: isWebPlayer
                  ? isPlaying ? "2px solid #FF6B35" : "1px solid #2C2B26"
                  : "1px solid #FFFDEF",
                marginTop: "5px",
                marginBottom: "6px",
                opacity: "0.8",
              }
        }
      />
    </div>
  );
}

export default GiftSong;
